import { StatusColors } from "../../../styles/scheme";
import { titleCase } from "../../../util/string";

export enum ShiftSessionStatus {
  unpublished = "unpublished",
  rostered = "rostered",
  notRostered = "notRostered",
  confirmed = "confirmed",
}

export namespace ShiftSessionStatus {
  export function toString(status: ShiftSessionStatus): string {
    switch (status) {
      case ShiftSessionStatus.confirmed:
        return "Confirmed";
      case ShiftSessionStatus.notRostered:
        return "Not rostered";
      case ShiftSessionStatus.rostered:
        return "Rostered";
      case ShiftSessionStatus.unpublished:
        return "Unpublished";
      default:
        return titleCase(status);
    }
  }

  export function toColor(status: ShiftSessionStatus) {
    switch (status) {
      case ShiftSessionStatus.confirmed:
        return StatusColors.green;
      case ShiftSessionStatus.notRostered:
        return StatusColors.red;
      case ShiftSessionStatus.rostered:
        return StatusColors.yellow;
      case ShiftSessionStatus.unpublished:
      default:
        return StatusColors.grey;
    }
  }
}
